import Vue from 'vue';
import billTransformer from '../../transformers/bill';

const success = (data, resolve) => {
  const result = {
    errors: data.errors,
    data: billTransformer.fetchCollection(data.data),
  };
  resolve(result);
};

const failed = (error, reject) => reject(error);

export default (billIds, data) => (
  new Promise((resolve, reject) => {
    const url = `/bills/bulk_mark_as_paid?bill_ids=${billIds.join(',')}`;
    Vue.$http
      .post(url, data)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/bill/bulkMarkAsPaid.js